An optional free-text billing reference.

SEEK does not use this field on unposted position profiles.
